import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../registry/paths';
import { pickRandom } from '../lib/random';

// One button, no list and no hints: it leads somewhere, and you find out where when you get there
function SidebarNav() {
  const navigate = useNavigate();

  return (
    <nav className="ms-box fm-nav" aria-labelledby="fm-explore-title">
      <h2 className="ms-box-title" id="fm-explore-title">Explore</h2>
      <div className="ms-box-body fm-portal">
        <button type="button" className="fm-portal-btn" onClick={() => navigate(pickRandom(PATHS, 1)[0].path)}>
          <span aria-hidden="true">✦</span> step through <span aria-hidden="true">✦</span>
        </button>
      </div>
    </nav>
  );
}

export default SidebarNav;
